var render = function render(){var _vm=this,_c=_vm._self._c;return _c('h1',{staticClass:"card-title mb-2",class:_vm.classes,style:({
    textAlign: `${_vm.align || 'auto'}!important`,
  })},[_vm._t("default",function(){return [_vm._v(_vm._s(_vm.title))]})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }